import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@env/*';

if (environment.production) {
  enableProdMode();
}

const externalToken = new URLSearchParams(window.location.search).get('token');

if (externalToken) {
  localStorage.setItem(environment.authToken, externalToken);

  const params = new URLSearchParams(window.location.search);
  params.delete('token');
  const query = params.toString();
  window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
